import { render, staticRenderFns } from "./CriticalProblemCard.vue?vue&type=template&id=72726eaa&scoped=true&"
import script from "./CriticalProblemCard.vue?vue&type=script&lang=js&"
export * from "./CriticalProblemCard.vue?vue&type=script&lang=js&"
import style0 from "./CriticalProblemCard.vue?vue&type=style&index=0&id=72726eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72726eaa",
  null
  
)

export default component.exports